export interface IsEnableConfig {
    use_global: boolean;
    is_enabled: boolean;
}

export interface ValueConfig {
    use_global: boolean;
    is_enabled: boolean;
    value: number;
    value_type: "percent" | "amount";
}

export interface RangeConfig {
    use_global: boolean;
    is_enabled: boolean;
    value_min: number;
    value_min_type: "percent" | "amount";
    value_max: number;
    value_max_type: "percent" | "amount";
}


export interface AdjustConfigGlobal {
    adjust_no_exposed: { is_enabled: boolean };
    skip_low_coupon: { is_enabled: boolean; value: number; value_type: "percent" };
    adjust_max_step: { is_enabled: boolean; value: number; value_type: "percent" };
    reset_max_step: { is_enabled: boolean; value: number; value_type: "percent" };
    reset_on_ll: { is_enabled: boolean };
    reset_on_ll_countime: { is_enabled: boolean; value: number };
}

export const AdjustConfigGlobalDefault: AdjustConfigGlobal = {
    adjust_no_exposed: { is_enabled: false },
    skip_low_coupon: { is_enabled: false, value: 1, value_type: "percent" },
    adjust_max_step: { is_enabled: false, value: 0, value_type: "percent" },
    reset_max_step: { is_enabled: false, value: 0, value_type: "percent" },
    reset_on_ll: { is_enabled: false },
    reset_on_ll_countime: { is_enabled: false, value: 5 },
};

export interface AdjustConfig extends AdjustConfigGlobal {
    adjust_no_exposed: { use_global: boolean; is_enabled: boolean };
    skip_low_coupon: { use_global: boolean; is_enabled: boolean; value: number; value_type: "percent" };
    adjust_max_step: { use_global: boolean; is_enabled: boolean; value: number; value_type: "percent" };
    reset_max_step: { use_global: boolean; is_enabled: boolean; value: number; value_type: "percent" };
    reset_on_ll: { use_global: boolean; is_enabled: boolean };
    reset_on_ll_countime: { use_global: boolean; is_enabled: boolean; value: number };
    // Additional fields can be added here as needed
    adjust_discount_range?: { use_global: boolean; is_enabled: boolean; value_min: number; value_min_type: string; value_max: number; value_max_type: string };
    adjust_price_range?: { use_global: boolean; is_enabled: boolean; value_min: number; value_min_type: string; value_max: number; value_max_type: string };
}

export const AdjustConfigDefault: AdjustConfig = {
    adjust_no_exposed: {
        use_global: true,
        is_enabled: false
    },
    skip_low_coupon: {
        use_global: true,
        is_enabled: false,
        value: 1,
        value_type: "percent"
    },
    adjust_max_step: {
        use_global: true,
        is_enabled: false,
        value: 0,
        value_type: "percent"
    },
    reset_max_step: {
        use_global: true,
        is_enabled: false,
        value: 0,
        value_type: "percent"
    },
    reset_on_ll: {
        use_global: true,
        is_enabled: false,
    },
    reset_on_ll_countime: {
        use_global: true,
        is_enabled: false,
        value: 5
    },
    // Additional fields can be initialized here as needed
    adjust_discount_range: {
        use_global: true,
        is_enabled: false,
        value_min: 0,
        value_min_type: "amount",
        value_max: 70,
        value_max_type: "percent"
    },
    adjust_price_range: {
        use_global: false,
        is_enabled: true,
        value_min: 0,
        value_min_type: "item_price",
        value_max: 0,
        value_max_type: "item_price"
    }
};
